import { AppActionsTypes } from "./actions-types";

const INITIAL_STATE = {
  filterProvider: {
    region: [],
    rawProviderName: [],
    normalizedProviderName: [],
    exportId: [],
  },
  filterBau: {
    bauId: [],
    oemId: [],
    make: [],
    region: [],
    uploaded: [],
    utf8Status: [],
    qcStatus: [],
    uploadStatusServiceBus: [],
    finalAutoQC: [],
    pushedToFinalTable: [],
    logMonth: [],
    exportId: [],
  },
};
const qcReportsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AppActionsTypes.BAU_QC_FILTER:
      return {
        ...state,
        filterBau: action.payload,
      };
    case AppActionsTypes.PROVIDER_FILTER:
      return {
        ...state,
        filterProvider: action.payload,
      };

    default:
      return state;
  }
};

export default qcReportsReducer;
